<div class="flex flex-col w-full">
    <div class="font-extrabold text-xl py-4">
        Your details
    </div>
    <div class="text-black text-lg">
        For a secure online checkout process, we require a few essential details. Your information will never be shared and is stored with the utmost security.
    </div>

    <div class="flex flex-row bg-primary rounded-xl p-4 items-center my-8">
        <div class="flex flex-row justify-center text-base text-accent font-bold w-full items-center">
            <mat-icon svgIcon="heroicons_solid:check-circle" [color]="'primary'" class="mr-4 bg-white rounded-xl bg-opacity-70"></mat-icon>
            <p class="text-center">
                Your email address, name and ID number must be 100% accurate and identical to the details linked to the bank account you intend to use. 
            </p>
        </div>
    </div>

    <div class="flex flex-col w-full items-center">

        <div class="flex flex-col w-full md:w-1/2 py-2 justify-start">
            <div class="flex flex-row font-extrabold pb-2">
                Customer type:*
            </div>
            <div class="flex flex-row">
                <mat-radio-group aria-label="Select an option">
                    <mat-radio-button [color]="'primary'" [checked]="CustomerType == 'Individual'" class="mr-15" (change)="customerType($event)" value="Individual">Individual</mat-radio-button>
                    <mat-radio-button [color]="'primary'" [checked]="CustomerType !== 'Individual'" value="Business" (change)="customerType($event)">Business</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
        
        <div class="py-2 flex flex-col w-full md:w-1/2 justify-center">
            <form [formGroup]="yourDetailsForm" #yourDetailsNgForm="ngForm">

                <div *ngIf="CustomerType !== 'Individual'">
                    <!-- Business Name field -->
                    <mat-form-field class="w-full">
                        <mat-label>Business Name</mat-label>
                        <input id="businessName" matInput [formControlName]="'BusinessName'" placeholder="Business Name">
                        <mat-error *ngIf="yourDetailsForm.get('BusinessName').hasError('required')">
                            Bussiness name is required
                        </mat-error>
                    </mat-form-field>
    
                    <!-- Business Registration field -->
                    <mat-form-field class="w-full">
                        <mat-label>Business Registration</mat-label>
                        <input id="businessRegistration" matInput [formControlName]="'BusinessRegistration'" placeholder="Business Registration">
                        <mat-error *ngIf="yourDetailsForm.get('BusinessRegistration').hasError('required')">
                            Business Registration is required
                        </mat-error>
                    </mat-form-field>
    
                    <!-- Vat Number field -->
                    <mat-form-field class="w-full">
                        <mat-label>VAT Number</mat-label>
                        <input id="vatNumber" matInput [formControlName]="'VatNumber'" placeholder="Vat Number">
                        <mat-error *ngIf="yourDetailsForm.get('VatNumber').hasError('required')">
                            VAT Number is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Name field -->
                <mat-form-field class="w-full">
                    <mat-label>Name</mat-label>
                    <input id="name" matInput [formControlName]="'FirstName'" placeholder="First Name" (keyup)="isFormValid()">
                    <mat-error *ngIf="yourDetailsForm.get('FirstName').hasError('required')">
                        First name is required
                    </mat-error>
                </mat-form-field>

                <!-- Last Name field -->
                <mat-form-field class="w-full">
                    <mat-label>Surname</mat-label>
                    <input id="surname" matInput [formControlName]="'Surname'" placeholder="Last Name" (keyup)="isFormValid()">
                    <mat-error *ngIf="yourDetailsForm.get('Surname').hasError('required')">
                        Surname is required
                    </mat-error>
                </mat-form-field>

                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Email address</mat-label>
                    <input readonly id="email" matInput [formControlName]="'EmailAddress'" placeholder="Email Address" (keyup)="isFormValid()">
                    <mat-error *ngIf="yourDetailsForm.get('EmailAddress').hasError('required')">
                        Email address is required
                    </mat-error>
                </mat-form-field>

                <!-- Phone Number field -->
                <mat-form-field class="w-full">
                    <mat-label>Mobile Number</mat-label>
                    <input readonly id="mobileNumber" matInput [formControlName]="'MobileNumber'" placeholder="Mobile Number" (keyup)="isFormValid()">
                    <mat-error *ngIf="yourDetailsForm.get('MobileNumber').hasError('required')">
                        Phone number is required
                    </mat-error>
                </mat-form-field>

                <!-- Alt Phone Number field -->
                <mat-form-field class="w-full">
                    <mat-label>Alternative Phone Number</mat-label>
                    <input id="altNumber" matInput [formControlName]="'AlternativeNumber'" placeholder="Alternative Mobile Number" (keyup)="isFormValid()">
                </mat-form-field>

                <!-- ID Number field -->
                <mat-form-field class="w-full">
                    <mat-label>ID or Passport Number</mat-label>
                    <input readonly id="idNumber" matInput [formControlName]="'IDNumber'" placeholder="ID Number" (keyup)="isFormValid()">
                    <mat-error *ngIf="yourDetailsForm.get('IDNumber').hasError('required')">
                        ID number is required
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </div>
</div>